import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { System } from '../../../shared-components/System';
import { YearService } from '../../../shared-components/year/year.service';
import { AbsentNotice } from './absent-notice.model';

@Injectable({
  providedIn: 'root'
})
export class ReviewAbsentNoticesService {

  constructor(
    private http: HttpClient,
    private yearService: YearService
  ) { }

  getAbsentNoticesByYearAndDate(startDate: string, endDate: string): Observable<AbsentNotice[]> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID +
      '&startDate=' + startDate +
      '&endDate=' + endDate;
    return this.http.get<AbsentNotice[]>(System.apiURL.Admin + 'GetAbsentNoticesByYearAndDate' + queryString);
  }

  saveAbsentNotice(notice: AbsentNotice): Observable<AbsentNotice> {
      return this.http.post<AbsentNotice>(System.apiURL.Admin + 'SaveAbsentNotice', notice);
  }

  getAbsentNoticeByStudentId(studentId: number): Observable<AbsentNotice> {
      const queryString = '?studentId=' + studentId;

      return this.http.get<AbsentNotice>(System.apiURL.Admin + 'GetAbsentNoticeByStudentId' + queryString);
  }  
}
